export const phoneInputValidation = (value: string): string => (value || '').replace(/[^0-9]/g, '').slice(0, 10)
